{
  "welcome": "Welkom",
  "logout": "Uitloggen",
  "login": {
    "title": "Inloggen",
    "username": "Gebruikersnaam",
    "password": "Wachtwoord",
    "button": "Inloggen"
  },
  "dashboard": {
    "title": "Dashboard",
    "overview": "Overzicht",
    "settings": "Instellingen"
  },
  "errors": {
    "404": "Pagina niet gevonden",
    "500": "Interne serverfout",
    "unexpected": "Onverwachte fout",
    "somethingWentWrong": "Er is iets misgegaan",
    "failedToSaveRole": "Rol opslaan mislukt",
    "failedToSaveUser": "Gebruiker opslaan mislukt",
    "failedToLoadRoles": "Rollen laden mislukt",
    "failedToSaveUserRoles": "Gebruikersrollen opslaan mislukt",
    "failedToLoadUsers": "Gebruikers laden mislukt",
    "failedToSaveRoleUsers": "Rolgebruikers opslaan mislukt",
    "passwordRequired": "Wachtwoord is verplicht",
    "invalidEmailFormat": "Ongeldig e-mailformaat"
  },
  "button": {
    "new": "Nieuw",
    "edit": "Bewerk",
    "close": "Sluiten",
    "save": "Opslaan",
    "delete": "Verwijder",
    "newe": "Nieuwe",
    "create": "Creëer",
    "run": "Start",
    "saveAndClose": "Opslaan en sluiten"
  },
  "key": "Sleutel",
  "action": "Actie",
  "search": "Zoeken",
  "name": "Naam",
  "port": "Poort",
  "encryption": "Encryptie",
  "security": "Beveiliging",
  "enter": "Type",
  "menu": {
    "generalConfig": "Algemene Configuratie",
    "databaseConnections": "Database Connecties",
    "flowDefinitions": "Flow Definities",
    "flowInstances": "Flow Executies",
    "configuration": "Configuratie",
    "locks": "Sloten",
    "connections": "Connecties",
    "tables": "Tabellen",
    "users": "Gebruikers",
    "roles": "Rollen"
  },
  "roles": {
    "role": "Rol",
    "no-privileges-assigned-to-this-role": "Er zijn nog geen privileges toegekend aan deze rol",
    "assigned": "Toegekend",
    "users": "Gebruikers",
    "selectUsers": "Selecteer gebruikers",
    "searchUsers": "Zoek gebruikers...",
    "noUsersFound": "Geen gebruikers gevonden.",
    "ssoRoleId": "SSO Rol ID",
    "filterPrivileges": "Filter privileges",
    "updatedSuccessfully": "Rol succesvol bijgewerkt!",
    "createdSuccessfully": "Rol succesvol aangemaakt!"
  },
  "usersForm": {
    "roles": "Rollen",
    "selectRoles": "Selecteer rollen",
    "searchRoles": "Zoek rollen...",
    "noRolesFound": "Geen rollen gevonden.",
    "updatedSuccessfully": "Gebruiker succesvol bijgewerkt!",
    "createdSuccessfully": "Gebruiker succesvol aangemaakt!",
    "privilegesAvailableAfterCreate": "Privileges kunnen worden toegekend nadat de gebruiker is aangemaakt."
  },
  "tableView": {
    "useLocalTimezone": "Lokale tijdzone gebruiken?",
    "refresh": "Verversen",
    "searchAndFilter": "Zoeken en filteren"
  },
  "common": {
    "optional": "optioneel",
    "selfAdminGuardNote": "Opslaan wordt geblokkeerd als je je eigen admin-toegang verwijdert.",
    "privileges": "Privileges",
    "assignedSummary": "{{assigned}} van {{total}} toegekend",
    "noPrivilegesAvailable": "Geen privileges beschikbaar."
  },
  "select": "Selecteer",
  "general": "Algemeen",
  "value": "Waarde",
  "enter-here": "Voer in",
  "invalid": "Onjuist",
  "format": "formaat",
  "valid": "Correct",
  "execution-status-breakdown": "Verdeling per flow executie status",
  "Flow-execution-count-over-time": "Verloop aantal flow executies per dag",
  "flow-name": "Flow Naam",
  "schedule": "Plan in",
  "view-less": "Laat minder zien",
  "view-all": "Laat alles zien",
  "next": "Volgende",
  "previous": "Vorige",
  "scheduled-datetime": "Geplande datum en tijd",
  "timezone": "Tijdzone",
  "recurrence": "Herhaling",
  "yearly": "Jaarlijks",
  "monthly": "Maandelijks",
  "weekly": "Wekelijks",
  "daily": "Dagelijks",
  "none": "Geen",
  "flow-editor": {
    "add-lock": "Slot toevoegen",
    "additive": "aanvullend",
    "already-inherited": "al overgenomen",
    "definition-locks": "Definitie-sloten",
    "definition-locks-help": "Deze sloten komen uit de gekoppelde node-definitie.",
    "flow-node-locks": "Flow-node-sloten",
    "flow-node-locks-additive-help": "Flow-node-sloten worden toegevoegd aan definitie-sloten; ze vervangen ze niet.",
    "inherited-read-only": "overgenomen · alleen-lezen",
    "no-locks-left": "Geen sloten meer beschikbaar. Alle beschikbare sloten zijn al overgenomen, geselecteerd of wachten op selectie."
  },
  "monday": "maandag",
  "tuesday": "dinsdag",
  "wednesday": "woensdag",
  "thursday": "donderdag",
  "friday": "vrijdag",
  "saturday": "zaterdag",
  "sunday": "zondag",
  "select-days-of-the-week": "Selecteer de dagen van de week",
  "select-days-of-the-month": "Selecteer de dagen van de maand",
  "cancel": "Annuleer",
  "by": "op",
  "cancel-occurrences": "Annuleer executie",
  "cancel-series": "Annuleer herhaling",
  "limit": "Limiet",
  "scheduled-start-datetime": "Geplande start datum/tijd",
  "add-parameter": "Voeg parameter toe",
  "default-value": "Standaard waarde",
  "no-parameters-found": "Geen parameters gevonden",
  "library": "Bibliotheek",
  "content": "Inhoud",
  "error-not-authorized": "Geen Toegang",
  "workflows": {
    "name": "Bericht",
    "overview": "Workflows Overzicht",
    "chosen_option": "Antwoord",
    "parameters": "Variabelen",
    "original_message": "Origineel bericht"
  },
  "empty": "Leeg",
  "subject": "Onderwerp",
  "message": "bericht",
  "all": "Alles",
  "open": "Open",
  "open-parent-instance": "Open bovenliggende instantie",
  "closed": "Gesloten",
  "workflows.no_selected_workflow": "Geen workflow geselecteerd",
  "created_at": "Aangemaakt op",
  "workflows.last_updated": "Laatst bijgewerkt",
  "category": "Categorie",
  "date": "Datum",
  "audit_trail.created_at": "Datum/tijd",
  "username": "gebruiker",
  "user": "gebruiker",
  "audit_trail.audit_type": "type",
  "audit_trail.details": "details",
  "items_per_page": "# per pagina",
  "workflows.response_inputs": "Velden",
  "add-header": "Voeg header toe",
  "base-url": "Basis URL",
  "authentication-method": "Authenticatie methode",
  "grant-type": "Grant Type",
  "callback-url": "Callback URL",
  "authorization-url": "Autorisatie URL",
  "access-token-url": "Toegangstoken URL",
  "client-id": "Client ID",
  "client-secret": "Client Secret",
  "copy": "Kopieer",
  "mandatory": "Verplicht",
  "visible": "Zichtbaar",
  "evaluate_at_runtime": "Evalueer op runtime",
  "login.mail": "Mail",
  "View and manage your inbox": "Bekijk en beheer alle workflows in je inbox",
  "View and manage your node instances": "Bekijk en beheer alle node intances",
  "View and maintain all node definitions": "Bekijk en beheer alle node definities",
  "Raise Event": "Activeer gebeurtenis"
}
